<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle10')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle10') }}</h1>
    <p>{{ $t('artText10-1') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Design_Kitchen_in_Pixel-Perfect_Detail.webp`"
      :alt="'altImageDefault'"
    />
    <p>
      <b>{{ title1[0] }} {{ title1[1] }}</b
      >{{ title1[2] }}
    </p>
    <p>
      <b>{{ title2[0] }} {{ title2[1] }}</b
      >{{ title2[2] }}
    </p>
    <p>
      <b>{{ title3[0] }} {{ title3[1] }}</b
      >{{ title3[2] }}
    </p>
    <p>
      <b>{{ title4[0] }} {{ title4[1] }}</b
      >{{ title4[2] }}
    </p>
    <p>{{ $t('artText10-6') }}</p>
    <p>{{ $t('artText10-7') }}</p>
    <img
      :src="`${staticUrl}/images/DreamFlat_Design_Kitchen_in_Pixel-Perfect_Detail_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText10-8') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {getTranslateBySpanTag} from '~/helpers/baseFunction';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();
const title1 = computed(() =>
  getTranslateBySpanTag(t('artText10-2')),
);
const title2 = computed(() =>
  getTranslateBySpanTag(t('artText10-3')),
);
const title3 = computed(() =>
  getTranslateBySpanTag(t('artText10-4')),
);
const title4 = computed(() =>
  getTranslateBySpanTag(t('artText10-5')),
);

useSeoMeta({
  title: `${t('artSeoTitle10')}`,
  ogTitle: `${t('artSeoTitle10')}`,
  description: `${t('artSeoDesc10')}`,
  ogDescription: `${t('artSeoDesc10')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
